import { Navigate, useLocation } from 'react-router-dom'
import AuthService from 'services/auth'

export default function AdminRoute ({ children }) {
  const location = useLocation ()
  const isSigned = AuthService.isSigned ()
  const isAdmin = AuthService.isAdmin ()

  if (isSigned && isAdmin) {
    return children
  }

  return (
    <Navigate
      to='/admin/login'
      state={{ from: location }}
      replace
    />
  )
} 
